import React from 'react';
import { Box, Typography, Container, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';

const stats = [
    { label: 'Partner Brands', value: '85+' },
    { label: 'Ads Delivered', value: '250K+' },
    { label: 'Rewards Paid', value: '$35K+' },
    { label: 'Active Users', value: '1.5K+' },
];

const StatsBanner = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                py: 4,
                background: theme.palette.mode === 'dark' ? 'rgba(5, 5, 5, 0.6)' : 'rgba(255, 255, 255, 0.6)',
                borderTop: theme.palette.mode === 'dark' ? '1px solid rgba(255,255,255,0.05)' : '1px solid rgba(0,0,0,0.08)',
                borderBottom: theme.palette.mode === 'dark' ? '1px solid rgba(255,255,255,0.05)' : '1px solid rgba(0,0,0,0.08)',
                backdropFilter: 'blur(10px)',
                position: 'relative',
                overflow: 'hidden'
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={4} justifyContent="center">
                    {stats.map((stat, index) => (
                        <Grid item xs={6} md={3} key={index}>
                            <Box
                                component={motion.div}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: index * 0.1 }}
                                sx={{ textAlign: 'center' }}
                            >
                                <Typography
                                    variant="h4"
                                    sx={{
                                        fontWeight: 800,
                                        color: theme.palette.text.primary,
                                        mb: 0.5,
                                        textShadow: theme.palette.mode === 'dark' ? '0 0 20px rgba(0, 240, 255, 0.4)' : 'none'
                                    }}
                                >
                                    {stat.value}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: theme.palette.primary.main,
                                        textTransform: 'uppercase',
                                        letterSpacing: '1px',
                                        fontWeight: 600,
                                        fontSize: '0.8rem'
                                    }}
                                >
                                    {stat.label}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default StatsBanner;
